import NBType, { InferType } from '@netbase/nb-type'

/**
 * @typedef {object} SentenceInfoSchema
 * @property {string} documentFingerprint
 * @property {string} sentenceFingerprint
 * @property {string} sentenceNumber
 */
const SentenceInfoSchema = NBType.object().shape('SentenceInfoSchema', {
  /* @prop */
  documentFingerprint: NBType.string(),
  /* @prop */
  sentenceFingerprint: NBType.string(),
  /* @prop */
  sentenceNumber: NBType.string()
  /* END */
})
export default SentenceInfoSchema
export type SentenceInfo = InferType<typeof SentenceInfoSchema>
// RESERVE BELOW
